import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import _isEqual from 'lodash.isequal';
import SubsectionList from 'components_v2/mobile/SubsectionList';
// import ElectionWidget from 'components_v2/common/ElectionWidget';
import Loader from 'components/Loader';
import { getReactElementsFromInserts } from 'utils/inserts';
import { getSiteDomain, createSlug, randomNum } from 'utils/common';
import MovieReviewCard from 'routes/home/components/mobile/MovieReviewCard';
import makeRequest from 'utils/makeRequest';
import Card from 'components_v2/common/CardV2';
import CardCarousel from 'components_v2/common/CardCarousel/CardCarousel';
import LinkList from 'components_v2/mobile/LinksList';
import GadgetCard from 'components_v2/common/GadgetCard';
import Morebtn from 'components_v2/mobile/Morebtn';
// import NewscardComponent from 'components_v2/common/InitNewscardComponents';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import PaginationWidget from 'routes/newslisting/components/common/PaginationWidget/PaginationWidget';
// CARD-3692: temporary disabled
// import UtilityBeltV2 from 'components_v2/common/UtilityBeltV2/UtilityBeltV2';
// import { utilityBeltWrapperStyle } from 'components_v2/common/UtilityBeltV2/UtilityBeltV2.style';
// import IPLWidget from 'components_v2/mobile/IPLWidget';
import ToipNudges from 'components_v2/common/ToipNudges';
import { TOI_LIVE_DOMAIN } from '../../../../../constants';
// import { WAP_INDIA_HP_GA_CAT } from '../../../../../constants';
import Accordion from '../../../../home/components/desktop/AccordionV2/Accordion';
import s from './CoverLayout.scss';
import TOIPlusWidgetMobile from '../TOIPlusWidget/TOIPlusWidgetMobile';
import CalculatorCard from '../../../../calculator/components/mobile/CalculatorCard/CalculatorCard';
import FIFAWidget from '../../../../../components_v2/mobile/FifaWidget/Fifa';
import ElectionBattle from '../../../../../components/ElectionV2/common/ElectionBattle/ElectionBattle';
import ErrorBoundary from '../../../../../components/ErrorBoundary/ErrorBoundary';
import TOIPlusWidget from '../../../../../components_v3/desktop/TOIPlusWidget/TOIPlusWidget';

// CARD-3692: temporary disabled
// const utilityBeltStyle = {
//   ...utilityBeltWrapperStyle,
//   utilityBeltStyle: {
//     ...utilityBeltWrapperStyle.utilityBeltStyle,
//     marginTop: '0px',
//     mobileMarginBottom: '16px',
//   },
//   utilityBeltStyleInner: {
//     display: 'flex',
//     whiteSpace: 'nowrap',
//     overFlow: 'scroll',
//     margin: '0 -16px',
//     padding: '0 0 0 16px',
//   },
// };

class CoverLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      topStories: [],
      newStoryNumber: 0,
      refreshLoader: false,
      clientSide: false,
      loaderShow: false,
      moreData: [],
      activeTab: undefined,
      paginationUrl: props.sectionData.pagination
        ? props.sectionData.pagination.nextPageUrl
        : '',
      paginationData: props.sectionData.pagination,
      loadMoreDataUrl: props.sectionData
        ? props.sectionData.loadMoreDataUrl
        : '',
      currentTabName: '',
      headerHeading: null,
      starCandidatesData: [],
    };
  }
  // getElementArray = (elementArrayData, data) => {
  //   if (data instanceof Array && elementArrayData instanceof Array) {
  //     switch (elementArrayData.length) {
  //       case 1:
  //         return data.slice(0, 9).concat(elementArrayData.slice(0, 1));
  //       case 2:
  //         return data.slice(0, 8).concat(elementArrayData.slice(0, 2));
  //       case 3:
  //         return data.slice(0, 7).concat(elementArrayData.slice(0, 3));
  //       default:
  //         return null;
  //     }
  //   } else {
  //     return null;
  //   }
  // };

  static getDerivedStateFromProps(props, state) {
    const { sectionData: { id = '', items = [] } = {} } = props;
    if (
      state.topStories.length === 0 &&
      id === 'topstories' &&
      Array.isArray(items) &&
      items.length >= 1
    ) {
      return {
        topStories: items,
      };
    }
    return null;
  }

  componentDidMount() {
    const {
      sectionData,
      // loadIndiaHPData,
      // isPrime,
      // geocl,
      // geolocation,
      lazyload,
      // isTopStories,
      // isTopCity,
      // geoCityData,
    } = this.props;
    this.setState({ clientSide: true }, () => {
      if (
        sectionData &&
        !lazyload &&
        !Array.isArray(sectionData) &&
        sectionData.dataUrl
      ) {
        this.loadLayoutData(sectionData.dataUrl);
      }
    });
    if (
      sectionData &&
      sectionData.id === 'topstories' &&
      sectionData.isHP === 'yes'
    ) {
      this.intervalID = setInterval(
        () => this.loadAndCompareTopStoryData(),
        3 * 60 * 1000,
      );
    }
    // const { city } = geoCityData;
    // if (city && isTopStories && !isTopCity) {
    //   this.updateCityNewsInTopStories(city);
    // }
    this.loadLokSabhaCandidates();
    window.addEventListener('beforeunload', this.moveToTop);
    if (this.props.sectionData && this.props.sectionData.starCandidates) {
      this.refreshData();
    }
  }

  refreshData = () => {
    this.electionWidgetInterval = setInterval(() => {
      this.loadLokSabhaCandidates();
    }, 30 * 1000);
  };

  loadLokSabhaCandidates = () => {
    const { sectionData } = this.props;
    if (
      sectionData &&
      sectionData.starCandidates &&
      sectionData.electionState
    ) {
      const electionStateSlug = createSlug(sectionData?.electionState);
      const dataUrl = `${sectionData.starCandidates}?t=${randomNum()}`;
      makeRequest.get(dataUrl, {}, 'skipfeedengine').then(result => {
        if (!(result && result.data)) {
          return;
        }
        const starCandidateData =
          result.data && Array.isArray(result.data) && result.data.length > 0
            ? result.data.filter(candidates => {
                if (typeof candidates?.star === 'string') {
                  return (
                    electionStateSlug === createSlug(candidates?.sn) &&
                    candidates.star
                      .toLowerCase()
                      .split(',')
                      .includes('tois')
                  );
                }
                return false;
              })
            : [];
        this.setState({
          starCandidatesData: starCandidateData,
        });
      });
    }
  };

  setActiveTab = tab => {
    this.setState({
      activeTab: tab,
    });
  };

  loadSection = () => {
    const { sectionData } = this.props;
    if (sectionData && !Array.isArray(sectionData) && sectionData.dataUrl) {
      this.loadLayoutData(sectionData.dataUrl);
    }
  };
  // this function will load top story data and compare with previous data
  loadAndCompareTopStoryData = () => {
    const dataUrl = `${getSiteDomain()}/mobilehomepagefeedspadata.cms?feedtype=sjson&istoponly=y`;
    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (data && Array.isArray(data.data) && data.data.length) {
          this.compareTopStories(data.data);
        }
      });
  };

  componentDidUpdate(prevProps) {
    const { sectionData = {}, geoCityData: { city } } = this.props;
    const { geoCityData: { city: prevCity = '' } } = prevProps;
    // if (
    //   prevProps.sectionData &&
    //   this.props.sectionData &&
    //   prevProps.sectionData.id === 'topstories' &&
    //   prevProps.sectionData !== this.props.sectionData
    // ) {
    //   // eslint-disable-next-line no-unused-expressions
    //   Array.isArray(this.props.sectionData.items) &&
    //     this.compareTopStories(this.props.sectionData.items);
    // }
    if (
      sectionData &&
      sectionData.id === 'topstories' &&
      sectionData.isHP === 'yes' &&
      city &&
      prevCity !== city
    ) {
      // this.updateCityNewsInTopStories(city);
      // this.loadDataForTopStories(city);
    }
  }

  compareTopStories = newStories => {
    const { topStories = [] } = this.state;
    const previousStoriesId = this.getIdList(topStories);
    const newStoriesId = this.getIdList(newStories);
    const filteredArray = newStoriesId.filter(
      id => previousStoriesId.indexOf(id) === -1,
    );
    if (filteredArray.length >= 1) {
      // if (this.state.newStoryNumber < 1) {
      //   analyticsWrapper(
      //     'gaAndGrx',
      //     'send',
      //     'event',
      //     window.categoryForGA,
      //     'View_RefreshCTA',
      //     '',
      //     {
      //       nonInteraction: 1,
      //     },
      //   );
      // }
      this.setState({
        newStoryNumber: filteredArray.length,
      });
    } else {
      this.setState({ newStoryNumber: 0 });
    }
  };

  getIdList = (stories = []) => {
    const idList = [];
    stories.forEach(storyObject => {
      if (
        storyObject.id &&
        !(
          (storyObject && storyObject.ag === 'spotlight') ||
          storyObject.citynews === 'y'
        )
      )
        idList.push(storyObject.id);
    });
    return idList;
  };

  moveToTop = () => {
    if (this.state.refreshLoader) {
      window.scrollTo(0, 0);
      document.body.style.overflow = 'hidden';
    }
  };

  refreshPage = () => {
    // analyticsWrapper(
    //   'gaAndGrx',
    //   'send',
    //   'event',
    //   window.categoryForGA,
    //   'Click_RefreshCTA',
    //   '',
    // );
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'inactive_refresh',
      label: 'New Story',
    });
    this.setState({ newStoryNumber: 0, refreshLoader: true }, () =>
      window.location.reload(),
    );
  };

  updateCityNewsInTopStories = city => {
    if (!city) return;
    this.setState({ loading: false });

    const dataUrl = `${getSiteDomain()}/toihomepagecityfeedspadata.cms?feedtype=sjson&geocl=${city}`;

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          Array.isArray(data.data.items) &&
          data.data.items.length
        ) {
          const cityNews = data.data.items;
          try {
            // calling function to replace city news as per current user location
            this.updateCityNews(cityNews);
          } catch (e) {
            this.setState({ loading: false });
            console.log(e);
          }
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(e => {
        this.setState({ loading: false });
        console.log(e);
      });
  };

  updateCityNews = cityNews => {
    const { topStories = [] } = this.state;
    if (
      topStories &&
      Array.isArray(topStories) &&
      topStories.length > 10 &&
      Array.isArray(cityNews) &&
      cityNews.length
    ) {
      // deduping city news if already present in top stories
      const ctNews = this.dedupeCityNews(topStories, cityNews);
      let tmpcntr = 0;
      for (let i = 0; i < topStories.length; i += 1) {
        const tmpdata = topStories[i];
        if (tmpdata && tmpdata.citynews === 'y') {
          topStories[i] = ctNews[tmpcntr] || topStories[i];
          tmpcntr += 1;
          if (tmpcntr > ctNews.length - 1 || tmpcntr > 4) break;
        }
      }
      this.setState({ topStories, loading: false });
    }
  };

  dedupeCityNews = (topStoryNews, cityNews) => {
    const ctNews = [];
    for (let i = 0; i < cityNews.length; i += 1) {
      let match = false;
      for (let j = 0; j < topStoryNews.length; j += 1) {
        if (cityNews[i].id === topStoryNews[j].id) {
          match = true;
          break;
        }
      }
      if (!match) ctNews.push(cityNews[i]);
    }
    return ctNews;
  };

  componentWillUnmount() {
    clearInterval(this.intervalID);
    clearInterval(this.electionWidgetInterval);
    window.removeEventListener('beforeunload', this.moveToTop);
  }

  loadLayoutData = (
    dataUrl,
    ajaxCall,
    moreText,
    morePath,
    loadMoreDataUrl = '',
    currentTabName = '',
    headerHeading = null,
  ) => {
    if (!dataUrl) {
      return;
    }
    this.setState({ moreData: [] });
    this.setState({ loading: true });
    const isprime = this.props.isPrime ? '&pc1=yes' : '';
    const dataUrlLink = `${dataUrl}${isprime}`;

    makeRequest
      .get(dataUrlLink, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        // console.log('Data', data.data);
        if (
          (data &&
            data.data &&
            ((data.data.items && data.data.items.length > 0) ||
              data.data.length > 0)) ||
          (morePath.includes('/sports/football/fifa-world-cup') &&
            data.data &&
            data.data.standings)
        ) {
          this.setState({
            currentTabName,
            items: data.data.items || data.data,
            paginationData: data.data.pagination,
            paginationUrl: data.data.pagination
              ? data.data.pagination.nextPageUrl
              : '',
            ajaxCall: !!ajaxCall,
            loading: false,
            moreText,
            morePath,
            loadMoreDataUrl,
            headerHeading,
          });
        } else {
          this.setState({ loading: false });
        }
      });
  };

  loadMoreData(dataUrl, gaAction, seoPagination = false, ga4Type) {
    if (!dataUrl) {
      return;
    }
    this.setState({ loaderShow: true });

    const { gaCategory } = this.props;
    this.sendGA({
      gaCategory,
      gaAction: `${gaAction}-loadmore`,
      gaLabel: ``,
    });
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        label: `load_more_stories`,
        category: `${'click_cta'}`,
      });
    }
    // this.setState({ loading: true });

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          if (
            typeof window !== 'undefined' &&
            seoPagination &&
            data.data.pagination.cp &&
            data.data.pagination.cp > 1 &&
            data.data.pagination?.leafNode
          ) {
            let location = window.location.pathname;
            if (location.endsWith(`/${data.data.pagination.cp - 1}`)) {
              location = location.replace(
                new RegExp(`/${data.data.pagination.cp - 1}$`),
                `/${data.data.pagination.cp}`,
              );
            } else {
              location += `/${data.data.pagination.cp}`;
            }
            const query = window.location.search ? window.location.search : '';
            location = window.location.origin + location + query;
            window.history.pushState({}, '', location);
            analyticsWrapper(
              'gaAndGrx',
              'send',
              'pageview',
              window.location.href,
            );
          }
          this.setState({
            moreData: this.state.moreData.concat(data.data.items),
            paginationData: data.data.pagination,
            paginationUrl: data.data.pagination.nextPageUrl
              ? data.data.pagination.nextPageUrl
              : '',
          });
          this.setState({ loaderShow: false });
        } else {
          this.setState({ loading: false });
        }
      });
  }

  sendGA = data => {
    sendGaThroughProps({
      data,
    });
  };

  // getGeoBasedListingData = dataObj => {
  //   const { items } = dataObj;

  //   //changing coloum 1 data for US geo user
  //   let finalDataObj = {};
  //   // if (geolocation === '2' && inserts instanceof Array) {
  //   //   let elementArrayData;
  //   //   inserts.map(elementData => {
  //   //     if (elementData.geolocation === 'US') {
  //   //       elementArrayData = elementData.data;
  //   //     }
  //   //     return elementArrayData;
  //   //   });
  //   // we will get max 2 data object in inserts node

  //   if (elementArrayData && items) {
  //     const elementArray = this.getElementArray(elementArrayData, data);
  //     if (elementArray instanceof Array) {
  //       finalDataObj = elementArray;
  //     } else {
  //       finalDataObj = data;
  //     }
  //   } else {
  //     finalDataObj = data;
  //   }
  //   // } else {
  //   //   finalDataObj = data;
  //   // }
  //   return finalDataObj;
  // };

  renderComponent = () => {
    const {
      sectionData = {},
      typeComponentMapping,
      leadImageUpperLimit = 0,
      moreLink,
      hideMoreBtn = false,
      gaCategory,
      className,
      isPrime,
      keywords,
      cardsInsertsLite,
      geoCityData,
      ga4Type,
      ga4Category,
      isPaginationEnabled,
      sportsImagewidth,
      showDescription,
      showtimeStampHtml,
      isWapView,
      // CARD-3692: temporary disabled
      // utilityBeltInfo,
    } = this.props;
    const { topStories, newStoryNumber, refreshLoader } = this.state;
    if (sectionData && sectionData.dataUrl && !this.state.clientSide) {
      return null;
    }
    let listItems = [];
    let fifaListItem = {};
    if (this.state.ajaxCall) {
      listItems = this.state.items;
    } else if (sectionData.id === 'topstories') {
      listItems = topStories || sectionData.items || this.state.item;
    } else {
      listItems = sectionData.items || sectionData.data || this.state.items;
    }

    if (
      (sectionData.id === 'fifanews' &&
        this.state.currentTabName &&
        this.state.currentTabName === 'Results') ||
      this.state.currentTabName === 'Schedule' ||
      this.state.currentTabName === 'Points Table' ||
      this.state.currentTabName === 'Videos'
    ) {
      fifaListItem = this.state.items;
      listItems = [];
    }

    let MoviewReviewData = [];
    MoviewReviewData = sectionData.inserts && sectionData.inserts[0].items;

    const moreText = _get(sectionData, 'name') || 'more';
    let gaAction;
    let fifaGAEventLabel;
    let fifamoreBtnText;
    if (
      typeof sectionData.id !== 'undefined' &&
      sectionData.id !== 'fifanews'
    ) {
      gaAction = `click-${sectionData?.name.replace(/ /g, '').toLowerCase()}`;
    } else if (sectionData.id === 'fifanews') {
      fifaGAEventLabel = 'more_fifa_wc_2022';
      gaAction = 'click';
    }
    if (
      sectionData.id === 'fifanews' &&
      this.state.currentTabName &&
      this.state.currentTabName === 'Results'
    ) {
      fifaGAEventLabel = 'complete_results';
      gaAction = 'click';
      fifamoreBtnText = `COMPLETE RESULT`;
    } else if (
      sectionData.id === 'fifanews' &&
      this.state.currentTabName &&
      this.state.currentTabName === 'Schedule'
    ) {
      fifaGAEventLabel = 'complete_schedule';
      gaAction = 'click';
      fifamoreBtnText = `COMPLETE SCHEDULE`;
    } else if (
      sectionData.id === 'fifanews' &&
      this.state.currentTabName &&
      this.state.currentTabName === 'Points Table'
    ) {
      fifaGAEventLabel = 'complete_points_table';
      gaAction = 'click';
      fifamoreBtnText = `COMPLETE POINTS TABLE`;
    } else if (
      sectionData.id === 'fifanews' &&
      this.state.currentTabName &&
      this.state.currentTabName === 'Videos'
    ) {
      fifamoreBtnText = `FIFA MORE VIDEOS`;
    }

    const { clubStories = [] } = sectionData;
    const { loadMoreDataUrl, paginationUrl } = this.state;
    listItems =
      Array.isArray(listItems) && listItems.length
        ? listItems.map(item => {
            if (
              item &&
              item.wu &&
              item.tn === 'news' &&
              item.wu.includes('articleshow')
            ) {
              item.wu = item.wu.replace(
                'timesofindia.indiatimes.com',
                'm.timesofindia.com',
              );
            }
            return item;
          })
        : [];

    const cardInsertContainer =
      cardsInsertsLite &&
      cardsInsertsLite.inserts &&
      sectionData &&
      sectionData.rhsCardId &&
      cardsInsertsLite.inserts[sectionData.rhsCardId];

    const { paginationData } = this.state;

    let loadMoreComponent = (
      <button
        // eslint-disable-next-line react/jsx-no-bind
        onClick={this.loadMoreData.bind(
          this,
          paginationUrl || loadMoreDataUrl,
          gaAction,
          sectionData.showseopagination,
          sectionData.ga4Type,
        )}
        className={s.loadMore}
      >
        {sectionData.moreText ? sectionData.moreText : `Load ${moreText}`}
        <i />
      </button>
    );

    if (
      isPaginationEnabled &&
      paginationData &&
      paginationData.leafNode &&
      paginationData.totalRecords &&
      paginationData.perpage
    ) {
      const totalPages = Math.ceil(
        paginationData.totalRecords / paginationData.perpage,
      );
      loadMoreComponent =
        totalPages > 1 ? (
          <PaginationWidget
            currentPage={1}
            location={this.props.location}
            totalStories={paginationData.totalRecords}
            storiesPerPage={paginationData.perpage}
            isMobile
          />
        ) : null;
    }
    return (
      <div
        className={`${s.col1} ${s[className]} ${className} ${
          this.state.loading ? s.loader : ''
        }
          ${
            this.props.sectionName === 'city' && sectionData.id === 'topstories'
              ? s[this.props.sectionName]
              : ''
          } ${sectionData.id === 'topstories' && s.topStory} ${
          sectionData && sectionData.name === 'More Stories'
            ? s.morestories_wrapper
            : ''
        }`}
      >
        {refreshLoader && (
          <PopupPortal usePopupPortal={refreshLoader}>
            <div className={s.refresh_loader} />
          </PopupPortal>
        )}
        {newStoryNumber >= 1 && (
          <PopupPortal usePopupPortal={newStoryNumber >= 1}>
            <InViewObserver
              inViewCallback={() => {
                analyticsWrapper('ga4', {
                  event: 'user_shown',
                  type: `inactive_refresh`,
                  label: `${newStoryNumber === 1 ? 'Story' : 'Stories'}`,
                });
              }}
            >
              <button
                id="refresh-button"
                className={`${s.new_story_btn} ${
                  window.isStickyHeader ? 'sticky' : ''
                }`}
                onClick={this.refreshPage}
              >
                {`${newStoryNumber} New ${
                  newStoryNumber === 1 ? 'Story' : 'Stories'
                }`}{' '}
                <img
                  src="https://timesofindia.indiatimes.com/photo/86578216.cms"
                  alt="refresh icon"
                />
              </button>
            </InViewObserver>
          </PopupPortal>
        )}
        {this.props.listingHeader ? (
          <SubsectionList
            data={sectionData.subSections}
            dropdownTitle={sectionData.dropdownTitle}
            onChangeCallback={this.loadLayoutData}
            sectionId={sectionData.id}
            subHeading={sectionData.subHeading}
            showSearchBox
            gaData={{
              gaAction:
                sectionData.id !== 'fifanews'
                  ? this.props.tabChangeGaAction ||
                    `${sectionData.name}-TabChange`
                  : 'click',
              partialGaLabel: this.props.tabChangeGaLabel || 'Click',
            }}
            toggleLoader={this.toggleLoader}
            headingname={sectionData.name}
            headingLink={sectionData.link || sectionData.path}
            overrideClass={sectionData.className}
            linkData={{
              gaAction,
              gaLabel:
                (sectionData.path && sectionData.path.indexOf('http') > -1) ||
                (sectionData.link && sectionData.link.indexOf('http') > -1)
                  ? sectionData.link || sectionData.path
                  : `${TOI_LIVE_DOMAIN}${sectionData.link || sectionData.path}`,
            }}
            usePopupPortal={this.props.usePopupPortal}
            poweredByHtml={sectionData.poweredByHtml}
            setActiveTab={this.setActiveTab}
            geoCityData={geoCityData}
            cardDefaultTab={
              cardInsertContainer && cardInsertContainer.default_filter
            }
            sponsoredData={{
              sponsoredClass: sectionData.sponsoredClass,
              sponsoredLink: sectionData.sponsoredLink,
              sponsoredLogomsid: sectionData.sponsoredLogomsid,
              sponsoredTxt: sectionData.sponsoredTxt,
            }}
            isMobile={this.props.isMobile}
            sponsoredAd={sectionData.sponsoredAds}
            isPrime={this.props.isPrime}
            datads={sectionData}
            ga4Type={ga4Type}
            ga4Category={ga4Category}
          />
        ) : null}
        <div className={s.column}>
          {listItems instanceof Array &&
            listItems.map((item, itemIndex) => {
              let mappedComponent = null;
              let reactElement = [];
              const spotlightGA =
                item.ag && item.ag === 'spotlight'
                  ? `sl_${itemIndex + 1}_${item.id}`
                  : null;
              if (
                item.tn &&
                typeComponentMapping &&
                typeComponentMapping[item.tn]
              ) {
                reactElement = getReactElementsFromInserts(
                  {
                    insertsArray: [{ ...item }],
                    typeComponentMapping,
                  },
                  this.props.country,
                  itemIndex,
                  itemIndex <= leadImageUpperLimit,
                  this.props.isTOPVideosSlider ? 'Click' : gaAction,
                  sectionData?.id,
                  this.props.gaLabelPrefix,
                  this.props.isTOPVideosSlider
                    ? this.state.currentTabName || this.props.defaultTabName
                    : '',
                );
                if (
                  reactElement &&
                  reactElement.length === 1 &&
                  reactElement[0].component
                ) {
                  mappedComponent = reactElement[0].component;
                }
              } else {
                switch (item.tn) {
                  case 'toip_renew_nudge':
                    mappedComponent = (
                      <ToipNudges
                        viewType="ToiHpRenewNudge"
                        isWapView={isWapView}
                        userData={this.props.userData}
                      />
                    );
                    break;
                  case 'calccard':
                    mappedComponent = <CalculatorCard {...item} />;
                    break;
                  case 'TOIPlusWidget':
                    mappedComponent = (
                      <InViewObserver
                        inViewCallback={() => {
                          this.ga4ViewElement(item?.ga4Type, item?.ga4Category);
                        }}
                      >
                        <TOIPlusWidgetMobile
                          item={item}
                          isUserPrime={isPrime}
                        />
                      </InViewObserver>
                    );
                    break;
                  // CARD-3692: temporary disabled
                  // case 'signals_utilitybelt': {
                  //   if (this.props.isPrime) {
                  //     mappedComponent = (
                  //       <UtilityBeltV2
                  //         utilityBeltInfo={utilityBeltInfo}
                  //         pageCode="/homepage"
                  //         webText="Click for news and views curated for you"
                  //         mwebText="Click for news and views"
                  //         styles={utilityBeltStyle}
                  //         slidesToShow={4}
                  //         slidesToScroll={2}
                  //         isWapView
                  //       />
                  //     );
                  //   } else {
                  //     mappedComponent = null;
                  //   }
                  //   break;
                  // }
                  case 'movie-review': {
                    mappedComponent = (
                      <MovieReviewCard
                        data={item}
                        key={item.id}
                        isLead={itemIndex <= leadImageUpperLimit}
                      />
                    );
                    break;
                  }
                  case 'ePaperWidget':
                    mappedComponent = (
                      <TOIPlusWidget
                        item={item}
                        isPrime={this.props.isPrime}
                        isWapView
                      />
                    );
                    break;
                  default: {
                    if (sectionData.id === 'tech' && item.keyFeatures) {
                      mappedComponent = (
                        <GadgetCard
                          data={item}
                          doNotChangeURL={
                            item.dnc === '1' || sectionData.dnc === '1'
                          }
                          // showDescription={itemIndex <= leadImageUpperLimit}
                          isLeadImageNews={itemIndex <= leadImageUpperLimit}
                          isInlineSmallIconCard={
                            itemIndex > leadImageUpperLimit
                          }
                          //itemClass={itemIndex >= 0 && s.leadspacing}
                          key={`card_${itemIndex}`}
                          target={
                            item.target === '1' || sectionData.target === '1'
                          }
                          linkData={{
                            gaAction: `${gaAction}-${itemIndex}`,
                            gaLabel: `${item.wu}`,
                          }}
                          isHalfMobileTile={clubStories.indexOf(itemIndex) >= 0}
                        />
                      );
                    } else if (
                      Array.isArray(item.imagelist) &&
                      item.imagelist.length > 0
                    ) {
                      mappedComponent = (
                        <CardCarousel
                          data={item}
                          doNotChangeURL={
                            item.dnc === '1' || sectionData.dnc === '1'
                          }
                          // showDescription={itemIndex <= leadImageUpperLimit}
                          isLeadImageNews={
                            (itemIndex <= leadImageUpperLimit &&
                              !(
                                typeof item.type !== 'undefined' &&
                                item.type === 'nofeatured'
                              )) ||
                            item.type === 'featured'
                          }
                          isInlineSmallIconCard={
                            itemIndex > leadImageUpperLimit &&
                            item.type !== 'featured'
                          }
                          //itemClass={itemIndex >= 0 && s.leadspacing}
                          key={`card_${item.wu || itemIndex}`}
                          linkData={{
                            gaAction: `${gaAction}-${itemIndex}`,
                            gaLabel: `${item.wu}`,
                          }}
                          target={
                            item.target === '1' || sectionData.target === '1'
                          }
                          isHalfMobileTile={clubStories.indexOf(itemIndex) >= 0}
                          viewga={spotlightGA}
                          useContentVisibilty={this.props.useContentVisibilty}
                          insertCaptionPlatform="mobile"
                          ga4Type={ga4Type}
                          ga4Category={ga4Category}
                          gaIndex={itemIndex + 1}
                          enableRelatedStoriesSupport={
                            this.props.enableRelatedStoriesSupport
                          }
                          isCtnCpd={this.props.isCtnCpd}
                        />
                      );
                    } else {
                      mappedComponent = (
                        <Card
                          isWapView
                          data={item}
                          doNotChangeURL={
                            item.dnc === '1' || sectionData.dnc === '1'
                          }
                          // showDescription={itemIndex <= leadImageUpperLimit}
                          isLeadImageNews={
                            (itemIndex <= leadImageUpperLimit &&
                              !(
                                typeof item.type !== 'undefined' &&
                                item.type === 'nofeatured'
                              )) ||
                            item.type === 'featured'
                          }
                          isInlineSmallIconCard={
                            itemIndex > leadImageUpperLimit &&
                            item.type !== 'featured'
                          }
                          key={`card_${item.wu || itemIndex}`}
                          linkData={{
                            gaAction: `${gaAction}-${itemIndex}`,
                            gaLabel: `${item.wu}`,
                          }}
                          target={
                            item.target === '1' || sectionData.target === '1'
                          }
                          isHalfMobileTile={clubStories.indexOf(itemIndex) >= 0}
                          viewga={spotlightGA}
                          useContentVisibilty={this.props.useContentVisibilty}
                          insertCaptionPlatform="mobile"
                          shouldNotlazyloadImage={
                            sectionData?.id === 'topstories' &&
                            (item.type === 'featured' ||
                              itemIndex <= leadImageUpperLimit)
                          }
                          ga4Type={ga4Type}
                          ga4Category={ga4Category}
                          gaIndex={itemIndex + 1}
                          sportsImagewidth={sportsImagewidth}
                          showDescription={
                            sportsImagewidth && !isWapView
                              ? showDescription
                              : false
                          }
                          timeStampHtml={
                            showtimeStampHtml && !isWapView ? item.dl : ''
                          }
                          enableRelatedStoriesSupport={
                            this.props.enableRelatedStoriesSupport
                          }
                          isCtnCpd={this.props.isCtnCpd}
                          showNewLiveBtn={this.props.showNewLiveBtn}
                        />
                      );
                    }
                  }
                }
              }

              // const insertForCurrentPosition = reactElementsArray
              //   .filter(insertItem => insertItem.position === itemIndex)
              //   .map(insertItem => insertItem.component);
              // if (insertForCurrentPosition.length > 0) {
              //   return [mappedComponent, ...insertForCurrentPosition];
              // }
              return (
                <React.Fragment key={itemIndex}>
                  {mappedComponent}
                </React.Fragment>
              );
            })}
          {fifaListItem &&
            Object.keys(fifaListItem).length > 0 && (
              <FIFAWidget
                data={fifaListItem}
                headerHeading={this.state.headerHeading}
                currentTab={this.state.currentTabName}
              />
            )}

          {MoviewReviewData && (
            <Accordion
              data={MoviewReviewData}
              wrapperClass={s.movieReview}
              innerWrapperClass={s.innerWrapper}
              newga={this.props.newga ? this.props.newga : `click-moviereview-`}
            />
          )}
          {this.state.moreData &&
            this.state.moreData.map((item, itemIndex) => {
              const spotlightGA =
                item.ag && item.ag === 'spotlight'
                  ? `sl_${itemIndex + 1}_${item.id}`
                  : null;
              return (
                <Card
                  data={item}
                  doNotChangeURL={item.dnc === '1' || sectionData.dnc === '1'}
                  isInlineSmallIconCard
                  key={`card_${item.wu || itemIndex}`}
                  linkData={{
                    gaAction: `${gaAction}-${itemIndex + 5}`,
                    gaLabel: `${item.wu}`,
                  }}
                  target={item.target === '1' || sectionData.target === '1'}
                  isHalfMobileTile={clubStories.indexOf(itemIndex) >= 0}
                  viewga={spotlightGA}
                  useContentVisibilty={this.props.useContentVisibilty}
                />
              );
            })}
        </div>
        {/* {sectionData &&
          sectionData.id &&
          sectionData.id === 'assemblyelection' && (
            <ElectionWidget key="election-wdt-top10" />
          )} */}
        {/* {cardInsertContainer &&
          sectionData.rhsCardId && (
            <NewscardComponent
              isWapView
              cardsInsertsLite={cardInsertContainer}
              slot={sectionData.rhsCardId}
              apiUrl={this.props.apiUrl}
              tokens={cardsInsertsLite.whoami && cardsInsertsLite.whoami.tokens}
              campaignName={
                cardInsertContainer && cardInsertContainer.campaign_name
              }
              gaCat={WAP_INDIA_HP_GA_CAT}
              location={this.props.location}
              hideTabs
              externalFilterTab={this.state.activeTab}
            />
          )} */}
        {keywords &&
          keywords.length > 0 && (
            <LinkList
              sectionData={{
                data: [...keywords],
              }}
              cssSelector="newslisttrending"
              gaCategory={this.props.keywordGaCategory}
              gaAction={
                this.props.keywordGaAction &&
                `${this.props.keywordGaAction}Infocus-###index###`
              }
              gaLabel={this.props.keywordGaLabel}
            />
          )}

        {sectionData.cardkeywords &&
          sectionData.cardkeywords.dataUrl && (
            <LinkList
              heading={sectionData.cardkeywords.title}
              dataUrl={sectionData.cardkeywords.dataUrl}
              cardKeywordsFilter={this.state.activeTab}
              cssSelector="infocuskeywordlist"
              csr
            />
          )}
        {(!hideMoreBtn &&
          this.state.moreData.length < 1 &&
          (typeof sectionData.moretextarrow !== 'undefined' &&
            sectionData.moretextarrow === 'down')) ||
        (paginationUrl && !hideMoreBtn) ? (
          <>
            {!this.state.loaderShow && loadMoreComponent}
            {this.state.loaderShow && (
              <div className={s.loaderSpacing}>
                <Loader />
              </div>
            )}
          </>
        ) : (
          <>
            {moreLink &&
              !hideMoreBtn && (
                <Morebtn
                  moreText={moreText}
                  absoluteMoreText={
                    sectionData.id !== 'fifanews'
                      ? this.state.moreText || sectionData.moreText
                      : fifamoreBtnText
                  }
                  moreLink={this.state.morePath || moreLink}
                  doNotChangeURL={sectionData.dnc === '1'}
                  target={sectionData.target === '1'}
                  linkData={{
                    gaAction,
                    gaLabel: `${
                      sectionData.id !== 'fifanews'
                        ? this.state.morePath || moreLink
                        : fifaGAEventLabel
                    }`,
                    gaCategory,
                  }}
                  useLightBGMoreBtn={this.props.useLightBGMoreBtn}
                  ga4Type={ga4Type}
                />
              )}
          </>
        )}
        {this.state.starCandidatesData &&
          Array.isArray(this.state.starCandidatesData) &&
          this.state.starCandidatesData.length > 0 && (
            <div className={s.electionBattleWrap}>
              <ErrorBoundary>
                <ElectionBattle
                  isWapView
                  infiniteScroll={false}
                  slidesToShow={6}
                  slidesToScroll={6}
                  candidateLinking
                  starCandidateData={this.state.starCandidatesData}
                  blackArrow
                />
              </ErrorBoundary>
            </div>
          )}
      </div>
    );
  };
  // Ga4 widget view call
  ga4ViewElement = (ga4Type, ga4Category) => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `${ga4Type}`,
        category: `${ga4Category || ''}`,
      });
    }
  };
  render() {
    const { lazyload = false, ga4Type, ga4Category } = this.props;
    return (
      <>
        {lazyload ? (
          <InViewObserver
            inViewCallback={() => {
              this.loadSection();
              this.ga4ViewElement(ga4Type, ga4Category);
            }}
            viewMargin="600px 0px 600px 0px"
          >
            {this.renderComponent()}
          </InViewObserver>
        ) : (
          <InViewObserver
            inViewCallback={() => {
              this.ga4ViewElement(ga4Type, ga4Category);
            }}
          >
            {this.renderComponent()}
          </InViewObserver>
        )}
      </>
    );
  }
}

const cachedResultIfPresent = (function getCachedResultIfAvailable() {
  let cachedData = { geo: {}, userData: {} };
  return data => {
    if (!_isEqual(cachedData, data)) {
      cachedData = data;
    }

    return cachedData;
  };
})();

const mapStateToProps = state => ({
  isMobile: state.isMobile,
  isPaginationEnabled: _get(
    state,
    'common.siteConfig.isPaginationEnabled',
    undefined,
  ),
  userData: cachedResultIfPresent({
    userData: _get(state, 'login.userData', {}),
    geo: _get(state, 'geo', null),
  })?.userData,
});

CoverLayout.propTypes = {
  sectionData: PropTypes.shape({
    inserts: PropTypes.arrayOf(PropTypes.shape({})),
    starCandidates: PropTypes.string,
    electionState: PropTypes.string,
  }).isRequired,
  listingHeader: PropTypes.bool,
  typeComponentMapping: PropTypes.shape({}),
  leadImageUpperLimit: PropTypes.number,
  moreLink: PropTypes.string.isRequired,
  hideMoreBtn: PropTypes.bool,
  country: PropTypes.string,
  usePopupPortal: PropTypes.bool,
  geolocation: PropTypes.string,
  useContentVisibilty: PropTypes.bool,
  loadIndiaHPData: PropTypes.func,
  isPrime: PropTypes.bool,
  className: PropTypes.string,
  lazyload: PropTypes.bool,
  keywords: PropTypes.arrayOf(PropTypes.shape({})),
  cardsInsertsLite: PropTypes.shape({}),
  geoCityData: PropTypes.shape({
    state: PropTypes.string,
  }),
  location: PropTypes.string,
  keywordGaCategory: PropTypes.string,
  keywordGaAction: PropTypes.string,
  keywordGaLabel: PropTypes.string,
  tabChangeGaAction: PropTypes.string,
  tabChangeGaLabel: PropTypes.string,
  defaultTabName: PropTypes.string,
  isTOPVideosSlider: PropTypes.bool,
  useLightBGMoreBtn: PropTypes.bool,
  isMobile: PropTypes.bool,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
  isPaginationEnabled: PropTypes.bool,
  sportsImagewidth: PropTypes.bool,
  showDescription: PropTypes.bool,
  showtimeStampHtml: PropTypes.bool,
  isWapView: PropTypes.bool,
  isCtnCpd: PropTypes.bool,
};
CoverLayout.defaultProps = {
  listingHeader: false,
  typeComponentMapping: undefined,
  leadImageUpperLimit: undefined,
  hideMoreBtn: false,
  country: '',
  usePopupPortal: false,
  geolocation: undefined,
  useContentVisibilty: false,
  loadIndiaHPData: () => {},
  isPrime: false,
  className: '',
  lazyload: false,
  keywords: [],
  cardsInsertsLite: undefined,
  geoCityData: {},
  location: null,
  keywordGaCategory: undefined,
  keywordGaAction: undefined,
  keywordGaLabel: undefined,
  tabChangeGaAction: undefined,
  tabChangeGaLabel: undefined,
  defaultTabName: '',
  isTOPVideosSlider: false,
  useLightBGMoreBtn: false,
  isMobile: false,
  ga4Type: '',
  ga4Category: '',
  isPaginationEnabled: false,
  isCtnCpd: false,
  sportsImagewidth: false,
  showDescription: false,
  showtimeStampHtml: false,
  isWapView: false,
};

export default connect(mapStateToProps)(CoverLayout);
